import {Link} from 'react-router-dom'

export const ParagraphLink = ({ children, link }) => {
    return <p className="inline-block"><Link className="border-b border-opacity-0 hover:border-opacity-100 border-blue-300 text-blue-700 "  to={link}> {children}</Link></p>
}
  
export default ParagraphLink
  